var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5008 3.60444V3.59944L16.2433 5.27569L20.0008 3.86694L10.0008 0.116943L0.000793457 3.86694L10.0008 7.61694L13.7433 6.21319L10.0008 4.67069V4.66694L12.5008 3.60444ZM0.000793457 5.11694V16.3669L9.37579 19.8832V8.63319L0.000793457 5.11694ZM5.00079 16.4082L2.50079 15.4707V14.1369L5.00079 15.0744V16.4082ZM16.2508 6.52319V9.65444L13.7508 10.5919V7.46069L10.6258 8.63319V19.8832L20.0008 16.3669V5.11694L16.2508 6.52319Z",
    fill: "#8BA4BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.000793457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/Others.88301111735914f9649a93849d5e2c4a.svg";
export { ForwardRef as ReactComponent };